export const https = {
  baseUrl: 'https://eshangu.56qqt.net',
  zntt: 'https://zntt.56qqt.net'
}
